import React, { Component } from 'react';
import { Button, Table } from 'antd';
import { StaffWrapper } from './style';

class Staff extends Component {
    render() {
        const columns = [
            {
                title: 'Member Email',
                dataIndex: 'email',
                key: 'email',
                render: (email) => <div>{email}</div>
            },
            {
                title: 'Role',
                dataIndex: 'role',
                key: 'role',
                render: (role) => <div className="table-content">{role}</div>
            },
            {
                title: 'Remove',
                dataIndex: 'remove',
                key: 'remove',
                render: (remove) => <span className="anchor">{remove}</span>
            },
        ]
        const dataSource = [
            {
                email: 'tech@bitholla.com',
                role: 'tech',
                remove: 'Remove',
            },
        ]
        return (
            <StaffWrapper>
                <div className="card-container">
                    <div className="flex-content">
                        <div className="content-1">
                            Staff members of Exchange-52
                        </div>
                        <Button type="primary" className="invite-btn">
                            Invite Member
                        </Button>
                    </div>
                    <div className="content-2">
                        <div>Add a member to help setup your exchange</div>
                        <div>Members will be given certain amount of access to</div>
                        <div>your exchange setup for the purpose server setup.</div>
                    </div>
                </div>
                <div className="table-container">
                    <Table
                        columns={columns}
                        dataSource={dataSource}
                        rowKey={(data, index) => index}
                    />
                </div>
            </StaffWrapper>
        )
    }
}

export default Staff;